import * as React from "react";
import { useFormikContext } from "formik";
import groupBy from "lodash/groupBy";
import sortBy from "lodash/sortBy";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert, ListGroup } from "components/bootstrap";
import { frequencies } from "report/report-configuration-page/SchedulingFrequencyForm";
import { defaultCompare } from "logic/DefaultCompare";
import toUTCFrequencyTime from "report/report-configuration-page/toUTCFrequencyTime";
import SchedulingFrequenciesListItem from "./SchedulingFrequenciesListItem";
const StyledListGroup = styled(ListGroup)`
  clear: both;
  margin-bottom: 3px;
  padding: 0;
`;
const sortFrequencies = (schedulingFrequencies) => schedulingFrequencies.sort(
  (f1, f2) => defaultCompare(
    toUTCFrequencyTime(f1.frequency_configuration.time, f1.frequency_configuration.timezone),
    toUTCFrequencyTime(f2.frequency_configuration.time, f1.frequency_configuration.timezone)
  )
);
const SchedulingFrequenciesList = ({ onDelete, onUpdate, disabled }) => {
  const { t } = useTranslation("enterprise_report");
  const {
    values: { delivery }
  } = useFormikContext();
  const scheduling = delivery == null ? void 0 : delivery.scheduling;
  if (!(scheduling == null ? void 0 : scheduling.length)) {
    return /* @__PURE__ */ React.createElement(Alert, { className: "no-bm" }, t("scheduling_frequencies_list.no_scheduling"));
  }
  const groupedSchedulingFrequencies = groupBy(
    scheduling.map((schedulingFrequency, index) => ({ ...schedulingFrequency, originalIndex: index })),
    "frequency"
  );
  const sortedFrequencyGroups = sortBy(
    Object.entries(groupedSchedulingFrequencies),
    (item) => frequencies.indexOf(item[0])
  );
  return /* @__PURE__ */ React.createElement("div", { "data-testid": "schedule-list" }, sortedFrequencyGroups.map(([frequencyName, schedulingFrequencies]) => /* @__PURE__ */ React.createElement(StyledListGroup, { componentClass: "ul", key: frequencyName }, sortFrequencies(schedulingFrequencies).map(({ originalIndex, ...schedulingFrequency }) => {
    var _a, _b;
    return /* @__PURE__ */ React.createElement(
      SchedulingFrequenciesListItem,
      {
        schedulingFrequency,
        key: `${schedulingFrequency.frequency}-${(_a = schedulingFrequency.frequency_configuration) == null ? void 0 : _a.time}-${(_b = schedulingFrequency.frequency_configuration) == null ? void 0 : _b.timezone}`,
        onDelete: () => onDelete(originalIndex),
        onUpdate: (newSchedulingFrequency) => onUpdate(originalIndex, newSchedulingFrequency),
        disabled
      }
    );
  }))));
};
export default SchedulingFrequenciesList;
